
export const Footer = () => {
  return (
    <div className="w-full shadow h-14 bg-yellow text-blue-dark text-center leading-[3.5rem]">
      <span className="text-center">Developed with <span className="text-red">&#x2764;</span> by Harshitha</span>
    </div>
  )
};
